<rappider-crud-view-edit-form [config]="MODULE_CREATE_CONFIG"
                              [data]="moduleFormData"
                              [submitButtonLoading]="submitButtonLoading"
                              (fieldValueChange)="onFieldValueChange($event)"
                              (formSubmit)="onCreateModuleFormSubmit($event)"></rappider-crud-view-edit-form>